import { useCallback, useState } from "react";
import { exportMatchbackSalesItemizedReportCsv } from "../api/exportMatchbackSalesItemizedReportCsv/exportMatchbackSalesItemizedReportCsvApi";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadMatchbackSalesItemizedReportCsv() {
  const [downloading, setDownloading] = useState(false);

  const downloadCsv = useCallback(async (intacctId: string) => {
    if (!intacctId) return;

    setDownloading(true);

    try {
      const blob = await exportMatchbackSalesItemizedReportCsv(intacctId);
      const timestamp = new Date().toISOString().split("T")[0];
      const fileName = `matchback-sales-itemized-${intacctId}-${timestamp}.csv`;

      downloadFile(blob, fileName);
    } catch {
      // The axios interceptor already reported this to the user; swallowing here keeps
      // the click handler from raising an unhandled rejection.
    } finally {
      setDownloading(false);
    }
  }, []);

  return {
    downloading,
    downloadCsv,
  };
}
